import React, {memo} from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/index.scss';
import * as serviceWorker from './serviceWorker';
import {WS} from './utils/ws';
import {RPCApplication} from './rpc-application';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {Configs} from './configs';
import {persistor, store} from './store';
import {PersistGate} from 'redux-persist/integration/react';

const ws = new WS(Configs.WS_URL);

if (!Configs.IS_DEBUG) {
    window.onerror = function () {
        window.location.reload();
    };
}

export const Application = memo(function Application() {
    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <BrowserRouter>
                    <RPCApplication ws={ws}/>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    );
});

ReactDOM.render(
    <Application/>,
    document.getElementById('root'),
);

serviceWorker.unregister();
